import React from 'react';
import { BookMarked, GraduationCap, ShieldAlert, Sparkles, Feather } from 'lucide-react';

export default function StorySection() {
  return (
    <div className="max-w-5xl mx-auto px-4 py-8 space-y-10">
      
      {/* Title */}
      <div className="text-center space-y-3 border-b border-gray-200 pb-6">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-red-50 text-[#8B0000] border border-red-200 text-xs font-semibold">
          <BookMarked className="w-3.5 h-3.5" />
          Mazu Story 媽祖故事
        </div>
        <h1 className="text-3xl sm:text-4xl font-bold text-[#8B0000] font-serif">
          留美博士媽祖代言人——王崇禮
        </h1>
        <p className="text-gray-500 font-mono text-sm">
          A Journey of Faith, Science, and Divine Guidance
        </p>
      </div>

      {/* Main Story Container */}
      <div className="bg-white border border-gray-200 rounded-2xl p-6 md:p-10 shadow-sm space-y-8">
        
        {/* Intro */}
        <div className="space-y-4">
          <div className="flex items-center gap-3 border-b border-gray-200 pb-3">
            <GraduationCap className="w-7 h-7 text-[#8B0000]" />
            <h2 className="text-2xl font-bold text-[#8B0000] font-serif">
              白天大學教授，晚上媽祖問神解籤
            </h2>
          </div>

          <p className="text-gray-800 text-base sm:text-lg leading-relaxed font-serif">
            白天在學校當教授,晚上幫人解籤的問神達人王崇禮,是嘉義港口宮媽祖娘娘欽點傳授神道的學生;閉關49日之後,王崇禮拿到畢業證書,被授予的任务,就是要教導大家正確拜朝問神的方法,新書《神明所教的解籤訣竅》,就是奉媽祖旨意所寫,要讓所有信徒都能與神明溝通,不要再走冤枉路。
          </p>

          <p className="text-gray-800 text-base sm:text-lg leading-relaxed font-serif">
            王崇禮白天是大學教授,晚上則是媽祖的第一個學生,幫信徒解籤。他幫人解籤認真嚴謹,因為不敢解錯神明的旨意。
          </p>
        </div>

        {/* Story Highlight 1: 9/11 Miracle */}
        <div className="bg-red-50/70 border border-red-200 rounded-xl p-6 space-y-3">
          <div className="flex items-center gap-3 text-[#8B0000] font-bold text-lg font-serif">
            <ShieldAlert className="w-6 h-6 text-[#8B0000]" />
            <h3>媽祖入夢授課 躲過911事件</h3>
          </div>
          <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
            台灣留美博士王崇禮一連串考托福,拿到碩士學位後,繼續攻讀博士,全都是媽祖指示,甚至還讓他與同學躲過911恐怖攻擊。王崇禮說,那年八月底,學校有二個星期的假期,與同學相約去紐約,但卻夢見媽祖阻止不能去,當時沒有問原因,直到當天新聞出來時,對照訂票紀錄的班機,這才知道自己躲過死亡班機。
          </p>
        </div>

        {/* Story Highlight 2: 49-Day Retreat */}
        <div className="bg-amber-50/70 border border-amber-200 rounded-xl p-6 space-y-3">
          <div className="flex items-center gap-3 text-[#8B0000] font-bold text-lg font-serif">
            <Sparkles className="w-6 h-6 text-[#B8860B]" />
            <h3>閉關49天 教信徒與神明聊天</h3>
          </div>
          <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
            王崇禮出國讀書一路順遂,拿到博士學位後,立即有聘書上門,讓他升起移民定居美國的想法,豈料媽祖入夢來罵王崇禮[忘恩負義]。
          </p>
          <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
            在夢中,媽祖娘娘說,讓王崇禮出國拿到博士學位,就是要讓大家知道,宗教與科學是可以相通的,神明在幫忙信徒解惑時,就像是學校裡教授與學生的關係,學生要懂得問, 教授才能給到最佳的答案,只要掌握對的技巧,不需要去求助別人,自己就能跟神明溝通。
          </p>
        </div>

        {/* Story Highlight 3: Lessons */}
        <div className="space-y-3">
          <div className="flex items-center gap-3 border-b border-gray-200 pb-2">
            <Feather className="w-6 h-6 text-[#8B0000]" />
            <h3 className="text-xl font-bold text-[#8B0000] font-serif">
              不定時閉關 神明授課
            </h3>
          </div>
          <p className="text-gray-800 text-base leading-relaxed font-serif">
            回台灣後，王崇禮白天在大學教書，晚上則在廟裡幫忙問神解籤，有時得不定期閉關，因為媽祖娘娘與玉皇大帝要上課。
          </p>
          <p className="text-gray-800 text-base leading-relaxed font-serif">
            他說，媽祖娘娘來到夢裡，教授拜拜的正確方法,怎麼與神明溝通,怎麼樣去求籤,剛開始上課的時候，自己比較駑頓，還會被敲頭。直到七七四十九天後，王崇禮畢業了，媽祖娘娘發出畢業證書，也唱驪歌，但也是任務的開始。王崇禮說，所有相關的問神書籍，都是媽祖娘娘的旨意，他要求上課的內容全部都要寫出來，未來得開課傳授。
          </p>
        </div>

      </div>

    </div>
  );
}
